import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/sonner'
import { AuthProvider } from '@/features/auth/context/AuthContext'
import { queryClient } from '@/lib/query-client'
import { router } from '@/routes/router'
import { useConsoleCapture } from '@/features/feedback'
import { Analytics } from '@vercel/analytics/react'

/**
 * Root App Component
 *
 * Provides:
 * - React Query (server state management)
 * - Auth Context (global auth state)
 * - React Router (routing)
 * - Toast notifications (Sonner)
 * - Console error capture (for bug reports)
 */
function App() {
  // Initialize console capture globally
  useConsoleCapture()

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster />
        <Analytics />
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
